export const locales = {
  'en-US': require('./en-US.json')
};
